export enum IDetailsTagType {
  DATE,
  INDICATOR,
}

export interface IDetailsTag {
  targetValue: number | null;
  compSetValue: number | null;
  indicatorValue: string | number | null;
  type: IDetailsTagType;
  label?: string;
}

export interface IDetails {
  title: string;
  value: string;
  hint?: string;
  reverseIndicator?: boolean;
  tag?: IDetailsTag;
}

export interface IInfoBox {
  id?: string;
  title?: string;
  details: IDetails[];
}
